

import "../../../Foundation/stylable/colors.st.css.js";
import "../../../IconButton/IconButton.st.css.js";
import { classesRuntime, statesRuntime } from "./../../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_209_0_Header";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_209_0_Header__root","header":"wds_1_209_0_Header__header","breadcrumbsContainer":"wds_1_209_0_Header__breadcrumbsContainer","titleContainer":"wds_1_209_0_Header__titleContainer","titleBackButton":"wds_1_209_0_Header__titleBackButton","titleBackButtonIcon":"wds_1_209_0_Header__titleBackButtonIcon","titleColumn":"wds_1_209_0_Header__titleColumn","title":"wds_1_209_0_Header__title","actionsBar":"wds_1_209_0_Header__actionsBar"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-space-50":"--wds-space-50","wds-space-200":"--wds-space-200","wds-button-size-medium":"--wds-button-size-medium","wds-color-text-primary":"--wds-color-text-primary","wds-color-text-standard-primary-light":"--wds-color-text-standard-primary-light","wds-color-fill-standard-primary-hover":"--wds-color-fill-standard-primary-hover","wds-color-fill-standard-primary-active":"--wds-color-fill-standard-primary-active","wds-color-fill-light-primary-disabled":"--wds-color-fill-light-primary-disabled","wds-color-fill-light-primary-active":"--wds-color-fill-light-primary-active"}; 




